import { render, staticRenderFns } from "./footerMob.vue?vue&type=template&id=c32f73c8&scoped=true"
import script from "./footerMob.vue?vue&type=script&lang=js"
export * from "./footerMob.vue?vue&type=script&lang=js"
import style0 from "./footerMob.vue?vue&type=style&index=0&id=c32f73c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32f73c8",
  null
  
)

export default component.exports